import type { AccountData } from "./providers/mcp-registration";
import MCPRegistration from "./providers/mcp-registration";
import MCPRegistrationSkeleton from "./providers/mcp-registration-skeleton";
import MTNewswiresRegistration from "./providers/mt-newswires-registration";
import { DEFAULT_PROVIDER_CONFIG } from "./providers/default-provider-config";
import { completeMcpAuthCallback, reportMcpFailure } from "@/features/login/complete-mcp-auth-callback";
import McpCallbackForm, { type McpCallbackHandle } from "@/features/login/mcp-callback-form";
import { useGetSoftwareStatement } from "@/features/software-statement/api/get-software-statement";
import { useToast } from "@blueskydataplatform/shared-ui/hooks/use-toast";
import { useRef } from "react";

const FinishMCPRegistration = ({ accountData, isLoading }: { accountData: AccountData | null; isLoading: boolean }) => {
  const callbackRef = useRef<McpCallbackHandle>(null);
  const { toast } = useToast();
  const softwareStatementMutation = useGetSoftwareStatement();

  const handleSubmit = async () => {
    try {
      await completeMcpAuthCallback({
        permissions: accountData?.provider?.mcp?.permissions,
        fetchSoftwareStatement: input => softwareStatementMutation.mutateAsync(input),
        callbackRef,
        // Reachable by any signed-in user with an MCP link, not only new sign-ups, so this is
        // only safe because both screens word their button as the Allow and show where access goes.
        alreadyConsented: true,
      });
    } catch (error) {
      reportMcpFailure(error, message => toast.error(message));
      throw error;
    }
  };
  if (isLoading || !accountData) {
    return <MCPRegistrationSkeleton />;
  }

  const provider = accountData.provider;

  let content = null;
  if (provider?.id === "mt_newswires" || provider?.id === "mtnewswires") {
    content = <MTNewswiresRegistration accountData={accountData} onFinish={handleSubmit} />;
  } else {
    content = <MCPRegistration accountData={accountData} config={DEFAULT_PROVIDER_CONFIG} onFinish={handleSubmit} />;
  }

  return (
    <div>
      <McpCallbackForm handleRef={callbackRef} />
      {content}
    </div>
  );
};

export default FinishMCPRegistration;
